<template>
  <div class="ocr-content">
    <div class="back">
      <span @click="goBack"><van-icon name="down" class="icon" /></span>
      <span class="page-name">{{ identifyType === '0' ? '合格证/行驶证识别': '行驶证识别' }}</span>
    </div>
    <div class="header">
      <div class="title">
        <div class="line" />
        <div class="title-text">
          拍照温馨提示
        </div>
      </div>
      <div v-if="showTab" class="select-tab">
        <div class="tab-item" :class="identifyType === '0' ? 'active' : ''" @click="changeType('0')">
          合格证
        </div>
        <div class="tab-item" :class="identifyType === '1' ? 'active' : ''" @click="changeType('1')">
          行驶证
        </div>
      </div>
    </div>
    <div class="notes">
      <p class="first">
        请保证证件完整并占据照片80%以上，照片文字清晰可见，避免照片反光
      </p>
      <p class="two">
        因光线原因可能导致身份证识别错误，请仔细核对并验证信息
      </p>
    </div>
    <div class="identify-area">
      <div v-show="!showNewImg" @change="handleFile($event)">
        <input ref="fileBtn" type="file" class="refesh-input-file" accept="image/*">
      </div>
      <div v-if="!showNewImg" class="img-content">
        <img :src="imgUrlCamera" alt="">
        <p>{{ identifyType === '0' ? '合格证正面' : '行驶证正面' }}</p>
      </div>
      <div v-if="showNewImg" class="new-img">
        <img ref="currentImg" :src="ocrImag" alt="">
      </div>
      <div v-if="showTips" class="tips">
        <div class="img-tip">
          <img :src="imgUrlLeftTarget" alt="" class="left-img">
          <img :src="imgUrlRightTarget" alt="" class="right-img">
        </div>
        <div class="text-tips">
          <p>可放大、上下滑动<span class="line">|</span>关闭<img :src="imgUrlClose" alt="" class="close-img" @click="closeTips()"></p>
        </div>
      </div>
      <div v-if="showNewImg" class="tool-list">
        <div class="refesh" @change="handleFile($event)">
          <input ref="fileBtn" type="file" class="refesh-input-files" accept="image/*">
          <img :src="imgUrlRefresh" alt="">
        </div>
        <img :src="imgUrlSpinner" alt="" @click="rotateImg">
        <img :src="imgUrlEnlarge" alt="" @click="enlargeImg">
      </div>
    </div>
    <div class="OCR-form" :class="identifyType === '0' ? 'form-active' : ''">
      <div v-show="identifyType==='1'" class="form-item">
        <div class="item-left">
          车牌号码
        </div>
        <div class="item-right">
          <input v-model="carInfo.plateNo" type="text" maxlength="8">
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          车架号
        </div>
        <div class="item-right">
          <input v-model="carInfo.vin" type="text" maxlength="17">
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          发动机号
        </div>
        <div class="item-right">
          <input v-model="carInfo.engineNo" type="text">
        </div>
      </div>
      <div v-show="identifyType==='1'" class="form-item">
        <div class="item-left">
          注册日期
        </div>
        <div class="item-right">
          <div class="time-left">
            <span>{{ carInfo.registerDate }}</span>
          </div>
          <div class="time-img" @click="showRegisterSelect">
            <img :src="imgUrlTime" alt="">
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="item-left">
          发证日期
        </div>
        <div class="item-right">
          <div class="time-left">
            <span>{{ carInfo.issueDate }}</span>
          </div>
          <div class="time-img" @click="showIssueSelect">
            <img :src="imgUrlTime" alt="">
          </div>
        </div>
      </div>
      <div v-show="identifyType==='1'" class="form-item">
        <div class="item-left">
          所有人
        </div>
        <div class="item-right">
          <input v-model="carInfo.owner" type="text">
        </div>
      </div>
      <div v-show="identifyType==='1'" class="form-item">
        <div class="item-left">
          住址
        </div>
        <div class="item-right address">
          <van-field
            v-model="carInfo.address"
            rows="1"
            autosize
            type="textarea"
          />
        </div>
      </div>
      <div v-show="identifyType==='0'" class="form-item">
        <div class="item-left">
          品牌型号
        </div>
        <div class="item-right">
          <input v-model="carInfo.vehicleModelNo" type="text">
        </div>
      </div>
      <div v-show="identifyType==='0'" class="form-item">
        <div class="item-left">
          排量(ml)
        </div>
        <div class="item-right">
          <input v-model="carInfo.displacement" type="text">
        </div>
      </div>
      <div v-show="identifyType==='0'" class="form-item">
        <div class="item-left">
          功率(kw)
        </div>
        <div class="item-right">
          <input v-model="carInfo.power" type="text">
        </div>
      </div>
      <div v-show="identifyType==='0'" class="form-item">
        <div class="item-left">
          整备质量(kg)
        </div>
        <div class="item-right">
          <input v-model="carInfo.curbWeight" type="text">
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="sureOcr">
        确认
      </button>
    </div>
    <van-popup v-model="popupTimeVisible" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="mDate"
        :max-date="maxDate"
        @confirm="timeSure"
        @cancel="popupTimeVisible = false"
      />
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import Compressor from 'compressorjs'
export default {
  components: {
    'Loading': Loading
  },
  props: {
    vehicleInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showPage: {
      type: Boolean,
      default: true
    },
    shandongFlag: {
      type: Boolean,
      default: false
    },
    noCardNumActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgUrlCamera: api.imgAllUrl + '/camera.png',
      imgUrlClose: api.imgAllUrl + '/img-close.png',
      imgUrlEnlarge: api.imgAllUrl + '/img-enlarge.png',
      imgUrlRefresh: api.imgAllUrl + '/img-refesh.png',
      imgUrlSpinner: api.imgAllUrl + '/img-spin.png',
      imgUrlLeftTarget: api.imgAllUrl + '/left-target.png',
      imgUrlRightTarget: api.imgAllUrl + '/right-target.png',
      imgUrlTime: api.imgAllUrl + '/time-img.png',
      switchs: false, // loading开关
      showTab: true,
      showTips: false,
      ocrImag: '',
      identifyType: '0', // 证件类型： 0-合格证 1-行驶证
      popupTimeVisible: false,
      currentDate: '',
      mDate: new Date(2000, 1, 1), // 日期选择器最小显示日期
      maxDate: '',
      statues: '',
      carOwner: '', // 所有人--车主姓名
      ownerAddress: '', // 车主家庭地址
      showNewImg: false,
      imgDeg: 0,
      imgScale: 0,
      carInfo: {
        plateNo: '', // 车牌号码
        vin: '', // 车架号
        engineNo: '', // 发动机号
        registerDate: '', // 注册日期
        issueDate: '', // 发证日期
        owner: '', // 所有人
        address: '', // 住址
        vehicleModelNo: '', // 品牌型号
        displacement: '', // 排量
        power: '', // 功率
        curbWeight: '' // 整备质量
      },
      businessTypeObj: {
        'ZKICATM': 'NationalMarketing-CarInsuranceInfo',
        'DP_OWXPA': 'OfficialWX-CarInsuranceInfo'
      },
      systemOriginObj: {
        'ZKICATM': 'NationalMarketing',
        'DP_OWXPA': 'OfficialWX'
      },
      displacement: {
        scalar: 1,
        moveEnd: false
      }
    }
  },
  watch: {
    'ocrImag': function(newVal, oldVal) {
      if (this.showNewImg && this.identifyType === '0') {
        this.showTips = true
      }
    },
    'noCardNumActive': function(newVal, oldVal) {
      if (!newVal) {
        this.showTab = false
        this.identifyType = '1'
      } else {
        this.showTab = true
        this.identifyType = '0'
      }
      this.clearDate()
    }
  },
  mounted() {
    if (!this.noCardNumActive) {
      this.showTab = false
      this.identifyType = '1'
    } else {
      this.showTab = true
      this.identifyType = '0'
    }
    if (this.showNewImg && this.identifyType === '0') {
      this.showTips = true
    }
  },
  activated() {
    this.$store.commit('setShow', false)
  },
  methods: {
    goBack() {
      this.$emit('goBack')
    },
    closeTips() {
      this.showTips = false
      if (this.ocrImag && this.identifyType === '0' && !this.showTips) {
        this.touchImg()
      }
    },
    changeType(type) {
      if (this.identifyType !== type) {
        this.clearDate()
      }
      this.identifyType = type
    },
    clearDate() {
      if (this.$refs.currentImg) {
        this.$refs.currentImg.style.width = ''
        this.$refs.currentImg.style.height = ''
        this.$refs.currentImg.style.marginTop = ''
        this.$refs.currentImg.style.transform = ''
      }
      this.showNewImg = false
      this.ocrImag = ''
      this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      this.showTips = false
      this.carInfo = {
        plateNo: '', // 车牌号码
        vin: '', // 车架号
        engineNo: '', // 发动机号
        registerDate: '', // 注册日期
        issueDate: '', // 发证日期
        owner: '', // 所有人
        address: '', // 住址
        vehicleModelNo: '', // 品牌型号
        displacement: '', // 排量
        power: '', // 功率
        curbWeight: '' // 整备质量
      }
    },
    // OCR识别 0--合格证 1--行驶证
    handleFile(event) {
      // this.$emit('handleFile', event)
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg']
      const ext = file.name.toLowerCase().split('.').pop()
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      console.log(this.$refs.fileBtn, 'fileBtn')
      if (file.size > 20 * 1000 * 1000) {
        this.$toast('图片大小超过20M，请重新选择')
        return false
      } else {
        const that = this
        new Compressor(file, {
          quality: 0.5,
          maxWidth: 1200,
          success(result) {
            const reader = new FileReader()
            reader.readAsDataURL(result)
            const channelCode = localStorage.getItem('setChannelCode')
            const userCode = localStorage.getItem('setSalesCode')
            reader.onload = function(e) {
              const name = new Date().getTime()
              const param = {
                fileName: name + '.png',
                imageInBase64Format: e.target.result,
                serviceProvider: 'INTSIG', // 服务提供商
                businessType: that.businessTypeObj[channelCode], // 系统业务类型：0核心业务系统（0电子投保单；1电子保单；）1数字化营销平台销管中心（0电子合同），必传
                systemOrigin: that.systemOriginObj[channelCode], // 系统来源（0核心业务系统；1数字化营销平台销管中心），必传
                businessNo: channelCode === 'ZKICATM' ? userCode : checkFormat.generateUUID() // 系统业务唯一标识（投保单号、保单号、个人代理人唯一标识），必传
              }
              const apiUrl = that.identifyType === '0' ? api.vehicle_certificates : api.vehicle_licenses
              that.ocrImag = e.target.result
              that.showNewImg = true
              that.$nextTick(() => {
                that.$refs.currentImg.style.width = ''
                that.$refs.currentImg.style.height = ''
                that.$refs.currentImg.style.transform = `rotate(-${that.imgDeg}deg)`
              })
              that.imgDeg = 0
              that.switchs = true
              that.$http.post(apiUrl, param).then(res => {
                that.switchs = false
                if (res.data.rtnCode === '0000') {
                  if (that.identifyType === '0' && res.data.issueDate) {
                    const year = res.data.issueDate.substring(0, res.data.issueDate.indexOf('年'))
                    const month = res.data.issueDate.substring(res.data.issueDate.indexOf('年') + 1, res.data.issueDate.indexOf('月'))
                    const date = res.data.issueDate.substring(res.data.issueDate.indexOf('月') + 1, res.data.issueDate.indexOf('日'))
                    res.data.issueDate = `${year}-${month}-${date}`
                  }
                  that.carInfo = {
                    plateNo: that.identifyType === '1' ? res.data.plateNo : '', // 车牌号码
                    vin: that.identifyType === '0' ? res.data.vehicleVin : res.data.vin, // 车架号
                    engineNo: res.data.engineNo, // 发动机号
                    registerDate: that.identifyType === '1' ? res.data.registerDate : '', // 注册日期
                    issueDate: res.data.issueDate, // 发证日期
                    owner: that.identifyType === '1' ? res.data.owner : '', // 所有人
                    address: that.identifyType === '1' ? res.data.address : '', // 住址
                    vehicleModelNo: that.identifyType === '0' ? res.data.vehicleModelNo : res.data.model, // 品牌型号
                    displacement: that.identifyType === '0' ? res.data.displacement : '', // 排量
                    power: that.identifyType === '0' ? res.data.power : '', // 功率
                    curbWeight: that.identifyType === '0' ? res.data.curbWeight : '', // 整备质量
                    fileId: res.data.fileId // 图片暂存ID
                  }
                } else {
                  that.$toast(res.data.rtnMsg)
                }
              })
                .catch(err => {
                  console.log(err)
                  this.switchs = false
                })
            }
          }
        })
      }
    },
    // 图片旋转
    rotateImg() {
      if (this.displacement.moveEnd && this.identifyType === '0') {
        this.$refs.currentImg.style.transform = ''
        this.$refs.currentImg.style.transformOrigin = ''
        this.$refs.currentImg.style.top = ''
        this.$refs.currentImg.style.left = ''
        this.displacement.moveEnd = false
      }
      const img = new Image()
      img.src = this.ocrImag
      this.imgDeg += 90
      if (this.imgDeg >= 360) {
        this.imgDeg = 0
      }
      if (this.imgDeg === 90 || this.imgDeg === 270) {
        if (Number(img.width) > Number(img.height)) {
          this.$refs.currentImg.style.height = `${0.62 * 209}px`
          this.$refs.currentImg.style.width = '209px'
          this.$refs.currentImg.style.marginTop = (126 / 3.1) + 'px'
        }
      } else {
        if (Number(img.width) > Number(img.height)) {
          this.$refs.currentImg.style.width = img.width + 'px'
          this.$refs.currentImg.style.height = img.height + 'px'
        }
        this.$refs.currentImg.style.marginTop = 0
      }
      this.$refs.currentImg.style.transform = `rotate(${this.imgDeg}deg)`
    },
    // 放大图片
    enlargeImg() {
      this.$ImagePreview([this.ocrImag])
    },
    showRegisterSelect() {
      if (this.vehicleInfo.vehicleInfoSource === '1' && this.shandongFlag) {
        return false
      }
      this.maxDate = new Date()
      this.currentDate = new Date(this.vehicleInfo.enrollDate)
      this.popupTimeVisible = true
      this.statues = 'ShowRegist'
    },
    showIssueSelect() {
      this.maxDate = new Date()
      this.currentDate = new Date(this.vehicleInfo.issueDate)
      this.popupTimeVisible = true
      this.statues = 'ShowIssu'
    },
    // 确认日期选择
    timeSure(value) {
      if (this.statues === 'ShowRegist') {
        this.carInfo.registerDate = checkFormat.getTimeToDate(value)
      } else if (this.statues === 'ShowIssu') {
        this.carInfo.issueDate = checkFormat.getTimeToDate(value)
      }
      this.popupTimeVisible = false
    },
    sureOcr() {
      this.$emit('newSuccessOcr', this.carInfo)
    },
    touchImg() {
      const that = this
      let position_left = ''
      let position_top = ''
      this.$nextTick(() => {
        // 获取放大缩小的区域DOM
        const imgBox = that.$refs.currentImg
        // const imgBox = document.querySelector('.new-img')
        imgBox.addEventListener('touchstart', function(event) {
          const touches = event.touches
          const events = touches[0]
          const events2 = touches[1]
          //  第一个触摸点的坐标
          that.displacement.pageX = events.pageX
          that.displacement.pageY = events.pageY
          that.displacement.moveable = true
          if (events2) {
            that.displacement.pageX2 = events2.pageX
            that.displacement.pageY2 = events2.pageY
          }
          if (touches.length === 0) {
            const _obj = this.$refs.currentImg
            position_left = parseFloat(_obj.css('left').split('p')[0])
            position_top = parseFloat(_obj.css('top').split('p')[0])
          }
          that.displacement.originScale = that.displacement.scale || 1
        })
        document.addEventListener('touchmove', function(event) {
          if (!that.displacement.moveable) {
            return
          }
          event.preventDefault()
          const touches = event.touches
          const events = touches[0]
          const events2 = touches[1]
          // 双指移动
          if (events2) {
          //   第二个手指坐标在touchmove时候获取
            if (!that.displacement.pageX2) {
              that.displacement.pageX2 = events2.pageX
            }
            if (!that.displacement.pageY2) {
              that.displacement.pageY2 = events2.pageY
            }
            //  双指缩放比例计算
            const numerator = that.getDistance(
              {
                x: events.pageX,
                y: events.pageY
              },
              {
                x: events2.pageX,
                y: events2.pageY
              }
            )
            const denominator = that.getDistance(
              {
                x: that.displacement.pageX,
                y: that.displacement.pageY
              },
              {
                x: that.displacement.pageX2,
                y: that.displacement.pageY2
              }
            )
            const zoom = numerator / denominator
            // 应用在元素上的缩放比例
            const newScale = that.displacement.originScale * zoom
            // 最大缩放比例限制
            // if (newScale > 1) {
            //   newScale = 1
            // }
            //   记住使用的缩放值
            that.displacement.scalar = newScale
            console.log(that.displacement.scalar, '缩放')
            //   图像应用缩放效果
            imgBox.style.transform = `scale(${newScale})`
            //  设置旋转元素的基点位置
            imgBox.style.transformOrigin = '0px 0px 0px'
          } else if (touches.length === 0) {
            imgBox.css({
              'top': position_top + events.pageY - that.displacement.pageY + 'px',
              'left': position_left + events.pageX - that.displacement.pageX + 'px'
            })
          }
        })
        document.addEventListener('touchend', function(event) {
          that.displacement.moveable = false
          that.displacement.moveEnd = true
          delete that.displacement.pageX
          delete that.displacement.pageY
        })
      })
    },
    getDistance(start, stop) {
    // Math.hypot() 计算参数平方根
      return Math.hypot(stop.x - start.x, stop.y - start.y)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./ocrIdentify";
</style>



// WEBPACK FOOTER //
// src/pages/car/ocrIdentify/index.vue